import { type InputField } from "@gluestack-ui/themed";

type UIInputFieldProps = React.ComponentProps<typeof InputField>;

export const iconStyle = {
  hitStop: { top: 10, right: 10, bottom: 10, left: 10 },
  enlargedHitSlop: { top: 16, right: 16, bottom: 16, left: 16 }
};

export const bigInputProps: UIInputFieldProps = {
  fontFamily: "Inter_500Medium",
  // Doesn't work using number as fontWeight, it crashes on android.
  fontWeight: "500",
  "$web-fontFamily": "Inter",
  fontSize: "$2xl"
};
